import {
  createQuestions,
  getQuestionDetails,
  editQuestions,
  deleteQuestion,
  getQuestionListById,
  getQnAList,
  getFeedbackQuesList,
  getFeedbackDetailsById,
  getFeedbackDetailsByCampaignId
} from "@/http/system/qna.js";

export default {
  namespaced: true,
  state: {
    questionDetails: {},
    questionList: [],
    feedbackList: [],
    qnaList: [],
    feedbackDetails: {},
    feedbackDetailsCampaingn: {}
  },
  actions: {
    async createQuestionsAction(_, payload) {
      try {
        const res = await createQuestions(payload);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async editQuestionsAction(_, payload) {
      try {
        const res = await editQuestions(payload.id, payload.data);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deleteQuestionAction(_, data) {
      try {
        return await deleteQuestion(data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getQuestionDetailsAction({ commit }, data) {
      try {
        const resp = await getQuestionDetails(data);
        commit("SET_QUESTION_DETAILS", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getQuestionListByIdAction({ commit }, data) {
      try {
        const resp = await getQuestionListById(data.id, data.isSelfCare);
        commit("SET_QUESTION_LIST", resp.data);
        return resp;
      } catch (error) {
        commit("SET_QUESTION_LIST", []);
      }
    },
    async getQnAListAction({ commit }) {
      try {
        const resp = await getQnAList();
        commit("SET_QNA_LIST", resp.data.content);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getFeedbackQuesListAction({ commit }, data) {
      try {
        const resp = await getFeedbackQuesList(data);
        commit("SET_FEEDBACK_LIST", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getFeedbackDetailsByIdAction({ commit }, data) {
      try {
        const resp = await getFeedbackDetailsById(data);
        commit("SET_FEEDBACK_DETAILS", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getFeedbackDetailsByCampaignIdAction({ commit }, data) {
      try {
        const resp = await getFeedbackDetailsByCampaignId(data.id, data.campaignId);
        commit("SET_FEEDBACK_DETAILS_CAMPAINGN", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  mutations: {
    SET_QUESTION_DETAILS(state, payload) {
      state.questionDetails = payload;
    },
    SET_QUESTION_LIST(state, payload) {
      state.questionList = payload;
    },
    SET_QNA_LIST(state, payload) {
      state.qnaList = payload;
    },
    SET_FEEDBACK_LIST(state, payload) {
      state.feedbackList = payload;
    },
    SET_FEEDBACK_DETAILS(state, payload) {
      state.feedbackDetails = payload;
    },
    SET_FEEDBACK_DETAILS_CAMPAINGN(state, payload) {
      state.feedbackDetailsCampaingn = payload;
    }
  }
};
